import React from 'react';
import { Grid, Row, Col, Panel } from 'react-bootstrap';
import 'react-select/dist/react-select.css';


export class CodePlayground extends React.Component {

  render() {
    return (
      <Grid>
          <Row className="show-grid">
            {/* <Col xs={14} sm={14} md={14} lg={14}> */}
            <Panel bsStyle="success">
              <Panel.Heading>
                <Panel.Title componentClass="h3">Javascript Play Ground</Panel.Title>
              </Panel.Heading>
              <Panel.Body className="klipse">
              
              </Panel.Body>
            </Panel>
           
           {/* </Col> */}
          </Row>
       </Grid>
          );
        }
      }



// WEBPACK FOOTER //
// ./src/CodePlayground.js